import type { FooterApiResponse } from '@/shared/types/footer';

/**
 * Fetches footer data from the API
 * @returns Promise<FooterApiResponse>
 */
export const getFooterData = async (): Promise<FooterApiResponse> => {
  const baseURL =
    import.meta.env.VITE_BASE_API_URL || 'http://34.101.225.127:8080';
  const response = await fetch(`${baseURL}/sanur-api/v1/footer`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
